
<script>
export default {
  data() {
    return {
      email: undefined,
      password: undefined,
      firstName: undefined,
      lastName: undefined,
      userName: undefined,
    };
  },
  computed: {
    isEmailValid() {
      if (this.invitation) {
        return true;
      }
      // eslint-disable-next-line
      const emailRegex = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,6})$/;
      const result = emailRegex.test(String(this.email).toLowerCase());
      return result;
    },
    isPasswordValid() {
      return this.password && this.password.trim().length > 5;
    },
    isFirstNameValid() {
      return this.firstName && this.firstName.trim().length >= 2;
    },
    isLastNameValid() {
      return this.lastName && this.lastName.trim().length >= 2;
    },
    isUserNameValid() {
      /* var usernameRegex = /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{2,29}$/;
      let result = usernameRegex.test(String(this.userName).toLowerCase());
      return result; */
      return this.userName && this.userName.trim().length > 2;
    },
    hasError() {
      return (this.isEmailValid && this.isPasswordValid &&
        this.isFirstNameValid &&
        this.isLastNameValid &&
        this.isUserNameValid) !== true;
    },
  },
  methods: {
    emailChanged(email) {
      this.email = email;
    },
    companyNameChanged(companyName) {
      this.companyName = companyName;
    },
    passwordChanged(password) {
      this.password = password;
    },
    userNameChanged(userName) {
      this.userName = userName;
    },
    firstNameChanged(firstName) {
      this.firstName = firstName;
    },
    lastNameChanged(lastName) {
      this.lastName = lastName;
    },
    couponCodeChanged(couponCode) {
      this.couponCode = couponCode;
    },
  },
};
</script>

<style>
</style>
